module.exports = __webpack_public_path__ + "fe40a18f0df9d6ab1cc8a3937d6e56ab.svg";